import * as React from "react";
import FilterProps from "./FilterProps";
import SearchBar from "../SearchBar";
import StringFilter from "./filters/StringFilter";

interface TextFilterViewProps extends FilterProps {
  placeholder: string;
  filter?: StringFilter;
  filterType: new (key: string, value: string) => StringFilter;
  filterMinimumLength?: number;
}

interface TextFilterViewState {
  isPending: boolean;
  pendingValue: string;
}

export default class StringFilterView extends React.PureComponent<
  TextFilterViewProps,
  TextFilterViewState
> {
  private static UPDATE_PENDING_DURATION = 300;
  private timeout: number;

  constructor(props: TextFilterViewProps) {
    super(props);
    this.state = {
      isPending: false,
      pendingValue: "",
    };
  }

  render() {
    return (
      <SearchBar
        value={this.getValue()}
        className="no-wrap"
        placeholder={this.props.placeholder}
        onChange={(value) => {
          window.clearTimeout(this.timeout);
          this.setState({
            isPending: true,
            pendingValue: value,
          });
          if (
            this.props.filterMinimumLength === undefined ||
            value.length === 0 ||
            value.length >= this.props.filterMinimumLength
          ) {
            this.timeout = window.setTimeout(() => {
              this.changeFilter(value);
              this.setState({
                isPending: false,
              });
            }, StringFilterView.UPDATE_PENDING_DURATION);
          }
        }}
      />
    );
  }

  private getValue() {
    if (this.state.isPending) return this.state.pendingValue;
    return this.props.filter ? this.props.filter.value : "";
  }

  private changeFilter(value) {
    const fieldKey = this.props.fieldKey;
    if (value) {
      this.props.onChange(fieldKey, new this.props.filterType(fieldKey, value));
    } else {
      this.props.onChange(fieldKey, null);
    }
  }
}
